<template>
  <ul>
    <li v-on:click="checkValue(index)" v-for="(elem, index) in this.list" :key="index">
      <div class="content">
        <div class="checkbox">
          <Checkbox
            @change="checkValue(index)"
            :background="checked(index) ? 'white' : ''"
            :bind="checked(index)"
          ></Checkbox>
        </div>
        <p>{{ elem.message }}</p>
      </div>
    </li>
  </ul>
</template>

<script>
import Checkbox from '../Input/Checkbox';
export default {
  name: 'ListCheckStep',
  components: { Checkbox },
  props: ['list', 'step'],
  computed: {},
  methods: {
    checked(index) {
      return this.$store.getters.getChecked({ step: this.step, index: index });
    },
    checkValue(index) {
      this.$store.dispatch('setChecked', { step: this.step, index: index });
    },
  },
};
</script>

<style scoped>
li {
  cursor: pointer;
  list-style-type: none;
  padding: 0.2em 0;
}
ul {
  text-align: left;
  padding: 0;
  margin: 0;
}
.content {
  display: flex;
  align-items: center;
}
p {
  margin-block-start: 0;
}

li:hover .content > p {
  text-decoration: underline;
}
</style>
